<template>
	<div class="boundary-plus-upsell">
		<div class="boundary-plus-upsell__container">
			<div class="boundary-plus-upsell__text">
				<h2 class="boundary-plus-upsell__heading">{{ heading }}</h2>
				<p class="boundary-plus-upsell__body">{{ body }}</p>
			</div>
			<a
				:href="subscribe_email_href"
				class="button button--fill boundary-plus-upsell__cta"
			>
				Subscribe to Boundary +
			</a>
		</div>
	</div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps( {
	project: { required: true, type: Object },
	heading: { required: false, type: String, default: 'Boundary +' },
	body: { required: false, type: String, default: 'Stay connected to your project long after the final render. Subscribe to Boundary + for a monthly stream of high-quality images, animations and visual content, ready to support marketing campaigns, stakeholder engagement and project updates.' }
} );

const subscribe_email_href = computed( () => {
	const subject = encodeURIComponent( `Boundary+ subscription — ${props.project.title}` );
	const body = encodeURIComponent( `Hi,\n\nI'd like to subscribe to Boundary + for the project: ${props.project.title}.\n\nPlease let me know the next steps.\n\nThanks` );
	return `mailto:?subject=${subject}&body=${body}`;
} );
</script>
